// The one stale-aware status dot/pill. Every sync-dot in the UI routes through
// here so a band variant is ALWAYS applied — a stale/`unknown` metric renders
// muted (never the bare-green base `.sync-dot`), and warn/critical get their
// color. Banding semantics live in `lib/system-metrics.ts` (`pillClass`).

import type { CSSProperties, ReactNode } from 'react';
import { pillClass, type Band } from '@/lib/system-metrics';

/** A status dot that always carries its band variant (never bare-green). */
export function SyncDot({ band, style }: { band: Band | 'error'; style?: CSSProperties }) {
  return <span className={'sync-dot ' + pillClass(band)} style={style} />;
}

/** Band-tinted pill: dot + label (or custom children). */
export function SyncPill({
  band,
  label,
  style,
  children,
}: {
  band: Band | 'error';
  label?: ReactNode;
  style?: CSSProperties;
  children?: ReactNode;
}) {
  return (
    <div className={'sync-pill ' + pillClass(band)} style={style}>
      <SyncDot band={band} />
      {children ?? (label != null ? <span>{label}</span> : null)}
    </div>
  );
}
